import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CWLocationComponent } from './location.component';
import { CWTabsComponent } from './tabs.component';
import { CWObservationRecorderComponent } from './observation-recorder.component';
import { CWRvEnvironmentComponent, CWRvRobotMapComponent } from './omniviewer.component';
import { CWRobotStatusDotComponent } from './robot-status-dot.component';

@NgModule({
  declarations: [
    CWLocationComponent,
    CWTabsComponent,
    CWObservationRecorderComponent,
    CWRvEnvironmentComponent,
    CWRvRobotMapComponent,
    CWRobotStatusDotComponent,
  ],
  exports: [
    CWLocationComponent,
    CWTabsComponent,
    CWObservationRecorderComponent,
    CWRvEnvironmentComponent,
    CWRvRobotMapComponent,
    CWRobotStatusDotComponent,
  ],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WebcomponentWidgets {}
